export default {
    path: '/app-download',
    meta: {
        title: 'APP下载',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/app-download`),
}



// WEBPACK FOOTER //
// ./src/views/AppDownload/router.js